<template>
  <img :src="src" />
</template>

<script setup lang="ts">
import { computed } from "vue";

import shoppingIcon from "@/assets/images/icons/shopping-icon.png";
import { useProductsContext } from "../../useProductsContext";
import type { IProductTableData } from "@/types/db/product-category";

type Props = {
  row: IProductTableData;
};

const props = defineProps<Props>();
const ctx = useProductsContext();

/**
 * Resolved image URL — falls back to the shopping-icon asset when the row has
 * no picture configured (matches the legacy template behavior).
 *
 * @returns {string}
 */
const src = computed((): string => {
  return ctx.getPictureUrl(props.row) || shoppingIcon;
});
</script>
